<template>
  <div :id="modalId" :class="`modal fade ${customClass}`" ref="modal">
    <div class="modal-dialog" :class="[modalSize]" :style="`${width && `width:${width};`}${minWidth && `min-width:${minWidth};`}`">
      <div class="modal-content" :id="contentId">
        <div class="modal-background">
          <div class="back-head-image"></div>
          <div class="back-image"></div>
        </div>
        <div class="modal-header modal-new-header" @mousedown="handleMouseDown">
          <button v-if="closeShow" type="button" class="close" @click="handleClose">
            <span aria-hidden="true">&times;</span>
          </button>
          <slot name="header">{{ modalTitle }}</slot>
          <slot name="tabs"></slot>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div v-if="$slots.footer" class="modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Modal',
  props: {
    modalId: {
      type: String,
      default: 'modal-form'
    },
    modalSize: {
      type: String,
      default: '' //modal-lg/modal-sm
    },
    modalTitle: {
      type: String,
      default: '标题'
    },
    modalType: {
      type: String,
      default: 'modal' //modal or no-modal
    },
    closeShow: {
      type: Boolean,
      default: true
    },
    contentId: {
      type: String,
      default: 'contentId'
    },
    width: {
      type: String,
      default: ''
    },
    minWidth: {
      type: String,
      default: ''
    },
    isSubmitForm: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      modalHeight: 0,
      modalWidth: 0,
      modalOffsetLeft: 0,
      modalOffsetTop: 0
    }
  },
  mounted() {
    if (this.isSubmitForm && this.modalId == 'distribution-create-form') {
      $('.distribution-create-form').keydown(function(event) {
        if (event.keyCode == 13) {
          $('form').each(function() {
            event.preventDefault()
          })
        }
      })
    }

    if (this.isSubmitForm && this.modalId == 'equipment-create-form') {
      $('.equipment-create-form').keydown(function(event) {
        if (event.keyCode == 13) {
          $('form').each(function() {
            event.preventDefault()
          })
        }
      })
    }
    if (this.modalType === 'no-modal') {
      $(this.$refs.modal).modal({
        backdrop: false,
        show: false
      })
    }
    const _this = this
    $(this.$refs.modal).on('show.bs.modal', function() {
      _this.$emit('show')
    })
    //限制弹出框最大高度
    $(this.$refs.modal).on('shown.bs.modal', function() {
      let maxHeight = $('.modal-dialog', _this.$refs.modal).height()
      // let height = $('.modal-body', _this.$refs.modal).height()
      // if (maxHeight < height) {
      //   $('.modal-body', _this.$refs.modal).height(maxHeight)
      // }
      // $('.modal-body', _this.$refs.modal)[0].style.maxHeight =
      //   $('body').height() - 110 - (_this.$slots.footer ? 70 : 0) + 'px'
      _this.$emit('shown')
      _this.modalHeight = maxHeight
      _this.modalWidth = $('.modal-dialog', _this.$refs.modal).width()
      _this.modalOffsetLeft = $('.modal-dialog', _this.$refs.modal).offset().left
      _this.modalOffsetTop = $('.modal-dialog', _this.$refs.modal).offset().top
    })
    $(this.$refs.modal).on('hidden.bs.modal', function() {
      _this.$emit('hide')
    })
    $(this.$refs.modal).appendTo('body')
  },
  beforeDestroy() {
    let modal = this.$refs.modal
    $(modal).remove()
  },
  methods: {
    handleClose() {
      $(this.$refs.modal).modal('hide')
      this.$emit('close')
    },
    handleMouseDown(event) {
      const _this = this
      if (event.button !== 0) {
        return
      }
      let selectElement = document.getElementById(this.contentId)
      //计算当前元素距离可视区的距离
      let distanceX = event.clientX - selectElement.offsetLeft
      let distanceY = event.clientY - selectElement.offsetTop
      //获取弹框位置元素
      event.preventDefault()
      document.onmousemove = function(ev) {
        //计算移动的距离 （开始拖拽至结束拖拽的距离）
        let leftNum = ev.clientX - distanceX
        let topNum = ev.clientY - distanceY
        //边界值判定
        let maxL = document.documentElement.clientWidth - _this.modalWidth - _this.modalOffsetLeft
        let maxT = document.documentElement.clientHeight - _this.modalHeight - _this.modalOffsetTop
        if (leftNum < 0) {
          //左移
          leftNum = Math.abs(leftNum) > _this.modalOffsetLeft ? 5 - _this.modalOffsetLeft : leftNum
        } else {
          leftNum = leftNum > maxL ? maxL : leftNum
        }
        if (topNum < 0) {
          //上移
          topNum = Math.abs(topNum) > _this.modalOffsetTop ? 0 - _this.modalOffsetTop : topNum
        } else {
          topNum = topNum > maxT ? maxT : topNum
        }
        // 移动当前元素
        selectElement.style.left = leftNum + 'px'
        selectElement.style.top = topNum + 'px'
        return false
      }
      document.onmouseup = function() {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
}
</script>

<style lang="less" scoped>
.modal-dialog {
  transform: none !important;
}
</style>